import React from 'react';
import { Form, FormikConfig } from 'formik';

import { Button, Input, InputField } from '../../components';
import { FormContextProvider } from '../../context';
import { AuthHeader } from '../auth-header';
import { validationSchema } from './mfa-code-form.form';

export type MfaCodeFormValues = {
  code: string;
};

export type MfaCodeFormProps = {
  helpText?: string;
  isPending?: boolean;
  onChange?: () => void;
  onSubmit: FormikConfig<MfaCodeFormValues>['onSubmit'];
  onBack: () => void;
};

export const MfaCodeForm = ({
  helpText,
  isPending,
  onChange,
  onSubmit,
  onBack,
}: MfaCodeFormProps) => {
  return (
    <FormContextProvider<MfaCodeFormValues>
      initialValues={{ code: '' }}
      validationSchema={validationSchema}
      onChange={onChange}
      onSubmit={onSubmit}
    >
      <Form>
        <AuthHeader heading="Enter authentication code" helpText={helpText} />
        <div className="space-y-4 mb-8">
          <InputField name="code" showRequiredIndicator={false}>
            {(field) => (
              <Input
                autoComplete="one-time-code"
                inputMode="numeric"
                maxLength={6}
                placeholder="6-digit code"
                {...field}
              />
            )}
          </InputField>
        </div>
        <div className="flex justify-end space-x-2">
          <Button variant="outline" onClick={onBack}>
            Back to login
          </Button>
          <Button type="submit" isPending={isPending}>
            Login
          </Button>
        </div>
      </Form>
    </FormContextProvider>
  );
};
